module.exports = __webpack_public_path__ + "img/wa5.352d95b8.jpg";